import styled from "styled-components";

const Wrapper = styled.div`
  background-color: #f4f0ff;
  margin: 0rem;
  overflow-x: hidden;
`;

export { Wrapper };
